import { wxInit, myInit, transformToQueryUrl, getPlatform } from "../../../utils/common";
import JSBridge from "@xpeng/js-bridge";
import XPMotorApi from '@xpeng/xpmotors-jsbridge-api';

/**
 * 充电福利页需要在APP\小程序\普通浏览器中都可以打开，特殊考虑小程序页面跳转需要使用小程序的跳转方式，封装一个H5页面跳转方法
 * @param url 
 * @param params 
 */
export function goToPage(url: string, params = {}) {
  if (!url) return

  const UA = navigator.userAgent || '';
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

  if (isXPApp) {
    // 由于只有首页在APP内需要使用原生分享按钮，APP端需要使用原生提供的新开窗口打开链接方法，否则直接跳转会把分享按钮带到其他页面
    const urlObj = new URL(url);
    setTimeout(() => {
      // 安卓的openUrl如果打开的不是同域名的路径，会原地刷新，这里做个判断直接用浏览器路由跳转
      if (getPlatform() === 'android' && urlObj.host !== window.location.host) {
        window.location.href = transformToQueryUrl(url, params);
      } else {
        XPMotorApi.getSdk().callHandler('openUrl', {
          url: transformToQueryUrl(url, params)
        });
      }
    }, 300);
  } else if (isWXApp) {
    wxInit().then(wx => wx.miniProgram.navigateTo({ url: `/pages/webpage/index?pageUrl=${encodeURIComponent(transformToQueryUrl(url, params))}` }));
  } else if (isMyApp) {
    myInit().then(my => my.navigateTo({ url: `/pages/webpage/index?pageUrl=${encodeURIComponent(transformToQueryUrl(url, params))}` }));
  } else {
    setTimeout(() => {
      window.location.href = transformToQueryUrl(url, params);
    }, 300);
  }
}

/**
 * 使用原生分享按钮，触发自定义分享事件
 */
export function defineSelfShareAction(cb: () => void) {
  try {
    JSBridge.registerHandler('onActionButtonShowing', (data, responseCallback) => {
      // true = 显示, false = 隐藏
      const options = {
        share: true,
      };
      responseCallback(options);
    });
    JSBridge.registerHandler('onActionButtonClick', (data, responseCallback) => {
      const res = data instanceof Array ? data[0] : data;
      if (res.action === 'share') {
        // 通知原生端将要拦截该事件
        responseCallback({ preventDefault: true });
        // 触发自定义的事件
        cb()
      }
    });
  } catch (error) {
    console.log('defineSelfShareAction -->', error);
  }
}